import { gql, type TypedDocumentNode } from '@apollo/client'

export type CardTransactionsMissingDetailsCountCellContentDebitCardV2Fragment =
  { __typename?: 'DebitCardV2'; outstandingTransactions: number | null }

export const CardTransactionsMissingDetailsCountCellContentDebitCardV2FragmentDoc =
  gql`
    fragment CardTransactionsMissingDetailsCountCellContentDebitCardV2Fragment on DebitCardV2 {
      outstandingTransactions
    }
  ` as unknown as TypedDocumentNode<
    CardTransactionsMissingDetailsCountCellContentDebitCardV2Fragment,
    undefined
  >
